import { Component, Vue } from "vue-property-decorator";
import { KyotenData } from '@/models/KyotenData';
import { AccountService } from "@/services/account.service.ts";
@Component
export default class ComponentWithGroupShaten extends Vue {
  form: any = {
    kyotenCd: "",
    groupCd: "",
    shatenCd: ""
  };
  groupDataList: any = [];
  shatenDataList: any = [];
  kyotenDataList: KyotenData[] = [];
  groupCd = "";
  shatenCd = "";
  accountService = new AccountService();

  public async getGroupDataList() {
    const response = await this.accountService.getGroups();
    if (response && response.data) {
      this.$set(this, "groupDataList", response.data);
      this.form.groupCd = response.groupCd || "";
      this.form.shatenCd = response.shatenCd || "";
      this.groupCd = this.form.groupCd;
      this.shatenCd = this.form.shatenCd;
    }
    return response;
  }

  public async getKyotenDataList() {
    const response = await this.accountService.getKyotens(
      this.form.groupCd,
      this.form.shatenCd
    );
    if (response) {
      this.$set(this, "kyotenDataList", response);
    } else {
      this.$set(this, "kyotenDataList", []);
    }
  }

  public async getShatenDataList() {
    if (this.form.groupCd) {
      const response = await this.accountService.getShatens(
        this.form.groupCd
      );
      if (response) {
        this.$set(this, "shatenDataList", response);
        if (response.length === 1) {
          this.$set(this.form, "shatenCd", response[0].shatenCd);
          this.getKyotenDataList();
        }
      } else {
        this.$set(this, "shatenDataList", []);
      }
    }
  }

  public async selectGroup() {
    this.form.shatenCd = null;
    this.form.kyotenCd = "";
    this.kyotenDataList = [];
    this.getShatenDataList();
  }

  public async selectShaten() {
    this.form.kyotenCd = "";
    this.kyotenDataList = [];
    this.getKyotenDataList();
  }
}
